import sanityClient from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

import type { SanityImageSource } from "@sanity/image-url/lib/types/types";

export type Author = {
  name: string;
  avatar: SanityImageSource;
};

export type CommunityStory = {
  name: string;
  slug: Slug;
  avatar: SanityImageSource;
  position: string;
  bio: string;
  twitter?: string;
  link?: string;
  slack?: string;
  raycast?: string;
  content: string;
};

export type Slug = {
  _type: "slug";
  current: string;
};

export type BlogPost = {
  title: string;
  description: string;
  slug: string;
  content: string;
  authors: Author[];
  date: string;
  thumbnail: SanityImageSource;
};

export type Extension = {
  name: string;
  content: string;
  description: string;
  logo: string;
};

export const cmsClient = sanityClient({
  projectId: "jqu50r9b",
  dataset: "production",
  useCdn: true,
  apiVersion: "2022-08-08",
});

const builder = imageUrlBuilder(cmsClient);

export function imageUrlFor(source: SanityImageSource) {
  return builder.image(source);
}

export async function getAllBlogPosts(): Promise<BlogPost[]> {
  return cmsClient.fetch(`*[_type == "post"]{
    _id, _type, title, description, slug, content, date, thumbnail, authors[]->
  } | order(date desc)`);
}

export function getAllCommunityStories(): Promise<CommunityStory[]> {
  return cmsClient.fetch(`*[_type == "community_story"]`);
}
